import _ from 'lodash';
import React from 'react';

import classNames from 'classnames';
import {
  default as Dropzone,
  DROPZONE_TYPE_CLASS,
  DEFAULT_TYPE_CLASS
} from 'components/Dropzone';
import {ErrorField} from 'components/Fields';

import './styles.css';

class DropzoneField extends React.Component<any> {
  state = {
    wrongFormat: false
  };

  handleDrop = acceptedFiles => {
    const wrongFormat = _.isEmpty(acceptedFiles);

    if (wrongFormat) {
      this.setState({wrongFormat});
    } else {
      this.props.onFileDrop(acceptedFiles);
    }
  };

  render() {
    const {
      files,
      uploading,
      multiple,
      className,
      removeFile,
      acceptedFileTypes,
      meta: {touched, error},
      type
    } = this.props;
    const {wrongFormat} = this.state;

    const fieldClass = DROPZONE_TYPE_CLASS[type || DEFAULT_TYPE_CLASS];

    return (
      <div className={classNames(className, 'DropzoneField', fieldClass)}>
        <Dropzone
          onDrop={this.handleDrop}
          multiple={multiple}
          files={files}
          uploading={uploading}
          wrongFormat={wrongFormat}
          removeFile={removeFile}
          acceptedFileTypes={acceptedFileTypes}
          type={type}
        />
        <ErrorField touched={touched} error={error} />
      </div>
    );
  }
}

export default DropzoneField;
